import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { AuthGate } from './components/AuthGate'
import { Dashboard } from './components/Dashboard'
import { QuestionList } from './components/QuestionList'
import { QuestionDetail } from './components/QuestionDetail'
import { Positions } from './components/Positions'
import { Skills } from './components/Skills'
import { Memory } from './components/Memory'
import { CompanyResearch } from './components/CompanyResearch'
import { CompanyDetailPage } from './components/CompanyDetail'
import { WalletDashboard } from './components/WalletDashboard'
import { WalletDetail } from './components/WalletDetail'
import { LiveRuns } from './components/LiveRuns'
import { RunDetail } from './components/RunDetail'
import { Forecast } from './components/Forecast'
import { Calibration } from './components/Calibration'

function App() {
  return (
    <AuthGate>
      <Routes>
        {/* Forecast UI - Standalone route without Layout */}
        <Route path="/forecast" element={<Forecast />} />

        {/* Observatory UI - Internal dashboard */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="questions" element={<QuestionList />} />
          <Route path="question/:questionId" element={<QuestionDetail />} />
          <Route path="positions" element={<Positions />} />
          <Route path="runs" element={<LiveRuns />} />
          <Route path="runs/:runId" element={<RunDetail />} />
          <Route path="skills" element={<Skills />} />
          <Route path="memory" element={<Memory />} />
          <Route path="research" element={<CompanyResearch />} />
          <Route path="research/:companyId" element={<CompanyDetailPage />} />
          <Route path="wallets" element={<WalletDashboard />} />
          <Route path="wallets/:address" element={<WalletDetail />} />
          <Route path="calibration" element={<Calibration />} />
        </Route>
      </Routes>
    </AuthGate>
  )
}

export default App


